import React from 'react';

import { Tag } from 'antd';

import { LitigationStatus } from '../types';
import { LitigationIcon } from '@/components/icons/LitigationIcon';

type Props = {
  litigationState: LitigationStatus;
};

const LITIGATION_CONFIG = {
  FLAGGED: {
    color: 'orange',
    iconColor: '#8D540A',
    label: 'Litigation',
    textColor: '#8D540A',
  },
  SOLVED: {
    color: 'green',
    iconColor: '#389e0d',
    label: 'Litigation solved',
    textColor: '#389e0d',
  },
} as const;

export const LitigationTag = ({ litigationState }: Props) => {
  const config = LITIGATION_CONFIG[litigationState];

  return (
    <Tag
      data-testid="litigation-tag"
      bordered={false}
      color={config.color}
      icon={
        <LitigationIcon
          color={config.iconColor}
          height={15}
          width={15}
          style={{ flexShrink: 0 }}
        />
      }
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '.25rem',
        marginInlineEnd: 0,
        maxWidth: 'fit-content',
      }}
    >
      <span
        style={{
          color: config.textColor,
          fontWeight: 500,
          fontSize: '0.75rem',
          textTransform: 'initial',
          letterSpacing: 0,
        }}
      >
        {config.label}
      </span>
    </Tag>
  );
};
